import { AppBar, Toolbar, Typography, Button, Box, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../hooks/use-auth';
import { ROUTES } from '../../../router/routes-definitions';
import { LayoutLanguageSelector, LayoutThemeToggle, LayoutNotifications } from '.';
import { useOperatorLogo } from '../hooks/use-operator-logo';
import { useThemeStore } from '../../../store/theme';
import { AppOperator } from '../../../types/theme.types';
import { useLayoutStore } from '../../../store/layout';

export const LayoutNavigationBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authenticated, keycloakLogin } = useAuth();
  const operator = useThemeStore((s) => s.operator);
  const toggleDrawer = useLayoutStore((s) => s.toggleDrawer);
  const { getOperatorLogo } = useOperatorLogo();

  return (
    <AppBar position="fixed">
      <Toolbar>
        {authenticated && (
          <IconButton color="inherit" edge="start" onClick={toggleDrawer} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
        )}

        <Box
          sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer' }}
          onClick={() => navigate(ROUTES.HOME)}
        >
          {getOperatorLogo()}
          <Typography variant="h6" component="div" sx={{ ml: operator === AppOperator.DEFAULT ? 0 : 2 }}>
            Clusters Platform
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!authenticated && (
            <>
              <LayoutLanguageSelector />
              <LayoutThemeToggle />
            </>
          )}

          {authenticated ? (
            <LayoutNotifications />
          ) : (
            <Button color="inherit" onClick={keycloakLogin}>
              {t('auth.login')}
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
